import { useEffect, useRef } from 'react';

/**
 * This hook creates a script tags that is appended to the body of an html page
 * @param url
 * @returns void
 */

export default function useScript(urls: readonly string[]): void {
  const scriptElements = useRef<HTMLScriptElement[]>([]);

  useEffect(() => {
    scriptElements.current = urls.map((url: string): HTMLScriptElement => {
      const existingScriptElement = document.querySelector(`script[src="${url}"]`) as HTMLScriptElement;
      if (!existingScriptElement) {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.type = 'text/javascript';
        script.setAttribute('data-status', 'loading');
        document.body.appendChild(script);
        return script;
      }
      return existingScriptElement;
    });

    return () => {
      // cleanup
      scriptElements.current?.forEach(
        (scriptElement: HTMLScriptElement) => scriptElement && document.body.removeChild(scriptElement)
      );
    };
  }, [urls]);
}
